import getFuncByMode from '../../utils/getFuncByMode';

import loading from '../loading';
import loaded from '../loaded';

import mandi from './mandi';
import chuck from './chuck';

const modes = {
  mandi,
  chuck,
};

const selectProductForItem = itemId => (dispatch) => {
  dispatch(loading());

  const handler = getFuncByMode(modes);
  dispatch(handler(itemId));

  dispatch(loaded());
};
export default selectProductForItem;
